import { MessageDialogComponent } from './../../../message-dialog/message-dialog.component';
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup,ReactiveFormsModule, Validators  } from '@angular/forms';
import { ContactService } from './contact.service';
// import {MapsAPILoader} from '@agm/core';
import { MatDialog,MatDialogConfig } from '@angular/material/dialog';
import {Dialog, DIALOG_DATA, DialogModule} from '@angular/cdk/dialog';
import { DialogComponentComponent } from 'src/app/dialog-component/dialog-component.component';
import {CommonModule, DatePipe} from '@angular/common';
import { NewsService } from 'src/app/service/news.service';



declare let $: any;
declare var gtag: Function; // Declare gtag function

@Component({
  selector: 'app-home-eleven',
  templateUrl: './home-eleven.component.html',
  styleUrls: ['./home-eleven.component.scss'],
  providers: [DatePipe]
})
export class HomeElevenComponent implements OnInit {

  latestNews: any[];

  submitted: boolean = false; // show and hide the success message
  isLoading: boolean = false; // disable the submit button if we're loading
  responseMessage: string; // the response message to show to the user
  form: FormGroup;
  // google maps zoom level
  zoom: number = 18;
  showDialog = false;
  // initial center position for the map
  lat: number = 40.83433194301286;
  lng: number = 14.231501254137115;

  constructor(private formBuilder: FormBuilder, private contact:ContactService,private http: HttpClient, private dialog: MatDialog,public dialog2: Dialog, private newsService: NewsService,private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.buildForm();
    this.fetchLatestNews();
  }


  fetchLatestNews() {
    this.newsService.getLatestNews().subscribe((data) => {
      this.latestNews = data;
    });
  }

  public formattaDataItaliano(data: Date): string {
    const parsedDate = new Date(data);
    return this.datePipe.transform(parsedDate, 'dd/MM/yyyy HH:mm', 'it');
  }

  send(): void {
    const { name, email, message } = this.form.value;
      // Send an event to Google Analytics when the link is clicked
      gtag('event', 'click', {
        'event_category': 'Messaggio',
        'event_label': 'Invio_Mail',
        'value': 'Sergio'
      });
    var formData: any = new FormData();
      formData.append("name", this.form.get("name").value);
      formData.append("email", this.form.get("email").value);
      formData.append("message", this.form.get("message").value);
      this.isLoading = true; // sending the post request async so it's in progress
      //$('.preloader').fadeOut('slow');
      this.showloader();
      this.submitted = false; // hide the response message on multiple submits
    //alert(`Name: ${name}, Email: ${email}, Message: ${message} `);
    this.http.post("https://script.google.com/macros/s/AKfycbxtRPnDKqm_ZRwTlYURKyef2YlPUbu6yJzkbPgE260y4CoUCqIr_NoJYe9yZ5RMrZ0D/exec", formData).subscribe((response) => {
    //this.contact.PostMessage(this.form.value).subscribe(response => {
      this.form.reset();
      if (response["result"] == "success") {
        this.responseMessage = "Thanks for the message! I'll get back to you soon!";
      } else {
        this.responseMessage = "Oops! Something went wrong... Reload the page and try again.";
      }

      this.hideloader();
      this.form.enable(); // re enable the form after a success
      this.submitted = true; // show the response message
      this.isLoading = false; // re enable the submit button
      //$('.preloader').fadeOut('slow');
      console.log(response);

      // Open the dialog with the result
      const dialogRef = this.dialog2.open(MessageDialogComponent, {
        //width: 'auto', height: 'auto', position: { top: "20px" },
        minWidth: '300px',
        data: { success: true } // Pass any data you want to display in the dialog
      });
    },
    (error) => {
      this.responseMessage = "Oops! An error occurred... Reload the page and try again.";
      this.form.enable(); // re enable the form after a success
      this.submitted = true; // show the response message
      this.isLoading = false; // re enable the submit button
      console.log(error);
    });
  }

  private buildForm(): void {
    this.form = this.formBuilder.group({
      // name: this.formBuilder.control(null),
      // email: this.formBuilder.control(null),
      // message: this.formBuilder.control(null),
      name: this.formBuilder.control(null),
      email: this.formBuilder.control(null),
      message: this.formBuilder.control(null),
      privacyConsent: [false, Validators.requiredTrue]
    });
  }

  get privacyAgreementControl() {
    return this.form.get('privacyConsent');
}

  openInfoDialog(infoToShow:string, detailToShow:string):void{
    let how=null;
    let who=null;
    this.showDialog=true;
    if(infoToShow && infoToShow=='Rinnovo Patente'){
      how = 'Patente scaduta + Documento d’identità valido';
      who = 'CHI LO PUO’ RICHIEDERE: Intestatario Patente';
    
    }
    if(infoToShow && infoToShow=='Passaggio di Proprietà'){
      how = 'Certificato di Proprietà (CDP) cartaceo o digitale (CDPD) + Carta di circolazione';
      who = 'Presenza fisica, documento d’ identità in corso di validità e codice fiscale dell’acquirente e del venditore';
    
    }
    if(infoToShow && infoToShow=='Immatricolazini'){
      how = 'Targhe';
      who = 'Documento Unico di circolazione (DU)';
    }
    if(infoToShow && infoToShow=='Perdita di Possesso'){
      how = 'Denuncia di furto del veicolo + Documento d’identità valido dell’intestatario del veicolo';
      who = 'Certificato di proprietà o eventuale denuncia';
    }
    if(infoToShow && infoToShow=='RINNOVO PATENTI NAUTICHE'){
      how = 'Carta d’identità e codice fiscale (in corso di validità) + Patente nautica da rinnovare';
      who = 'Due fotografie formato tessera su sfondo bianco';
    }
    const dialogRef = this.dialog.open(DialogComponentComponent, {
      //width: 'auto', height: 'auto', position: { top: "20px" },
      //minWidth: '300px',
      data: { name: infoToShow, detail: detailToShow , come : how, chi:who} // Pass any data you want to display in the dialog
    });

    dialogRef.afterClosed().subscribe(() => {
      this.showDialog = false;
    });
  }


  private hideloader(): void {
  
    // Setting display of spinner
    // element to none
    document.getElementById('loadingS')
        .style.display = 'none';
}

private showloader(): void {
  
  // Setting display of spinner
  // element to none
  document.getElementById('loadingS').style.display='';
}

trackLinkClick(linkName: string) {
  // Send an event to Google Analytics when the link is clicked
  // gtag('event', 'click', {
  //   event_category: 'Prova',
  //   event_label: linkName
  // });

  gtag('event', 'click', {
    'event_category': 'Barra_Menu',
    'event_label': linkName,
    'value': 'Sergio'
  });
}

}
